var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticStyle: {
            display: "flex",
            "flex-wrap": "wrap",
            "justify-content": "space-between",
          },
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "132px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "字段名称：", prop: "columnName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "字段名称" },
                model: {
                  value: _vm.dataForm.columnName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "columnName", $$v)
                  },
                  expression: "dataForm.columnName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "显示名称：", prop: "displayName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "字段编码" },
                model: {
                  value: _vm.dataForm.displayName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "displayName", $$v)
                  },
                  expression: "dataForm.displayName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "字段类型：", prop: "columnType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "字段类型" },
                  on: { change: _vm.colChange },
                  model: {
                    value: _vm.dataForm.columnType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "columnType", $$v)
                    },
                    expression: "dataForm.columnType",
                  },
                },
                _vm._l(_vm.columnTypeList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否展示：", prop: "showInList" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "是否展示" },
                  model: {
                    value: _vm.dataForm.showInList,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "showInList", $$v)
                    },
                    expression: "dataForm.showInList",
                  },
                },
                _vm._l(_vm.trueOrFalseOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.dataForm.showInList == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "显示表达式：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "执行上下文字段表达式" },
                    model: {
                      value: _vm.dataForm.expression,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "expression", $$v)
                      },
                      expression: "dataForm.expression",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "是否展示显示名：", prop: "textType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "是否展示显示名" },
                  model: {
                    value: _vm.dataForm.textType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "textType", $$v)
                    },
                    expression: "dataForm.textType",
                  },
                },
                _vm._l(_vm.trueOrFalseOptions2, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否为查询参数：", prop: "isQueryParam" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "是否为查询参数" },
                  model: {
                    value: _vm.dataForm.isQueryParam,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "isQueryParam", $$v)
                    },
                    expression: "dataForm.isQueryParam",
                  },
                },
                _vm._l(_vm.trueOrFalseOptions3, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dataForm.columnType == 2,
                  expression: "dataForm.columnType==2",
                },
              ],
              attrs: { label: "转换类型：", prop: "desensitType" },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "转换类型", clearable: "" },
                  model: {
                    value: _vm.dataForm.desensitType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "desensitType", $$v)
                    },
                    expression: "dataForm.desensitType",
                  },
                },
                _vm._l(_vm.desensitTypeList, function (item) {
                  return _c("el-option", {
                    key: item.type,
                    attrs: { label: item.name, value: item.type },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dataForm.columnType == 2,
                  expression: "dataForm.columnType==2",
                },
              ],
              attrs: { label: "拼接前缀：" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "输入需要拼接的字段名称" },
                model: {
                  value: _vm.dataForm.prefix,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "prefix", $$v)
                  },
                  expression: "dataForm.prefix",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dataForm.columnType == 2,
                  expression: "dataForm.columnType==2",
                },
              ],
              attrs: { label: "拼接后缀：" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "输入需要拼接的字段名称" },
                model: {
                  value: _vm.dataForm.suffix,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "suffix", $$v)
                  },
                  expression: "dataForm.suffix",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dataForm.columnType == 2,
                  expression: "dataForm.columnType==2",
                },
              ],
              attrs: { label: "数据源类型：", prop: "datasetType" },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "请选择数据源类型" },
                  on: { change: _vm.datasrouceChg },
                  model: {
                    value: _vm.dataForm.datasourceType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "datasourceType", $$v)
                    },
                    expression: "dataForm.datasourceType",
                  },
                },
                _vm._l(_vm.datasourceTypeList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.text, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dataForm.columnType == 2,
                  expression: "dataForm.columnType==2",
                },
              ],
              attrs: { label: "数据格式：" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入数据格式" },
                model: {
                  value: _vm.dataForm.patternRegex,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "patternRegex", $$v)
                  },
                  expression: "dataForm.patternRegex",
                },
              }),
            ],
            1
          ),
          _vm.dataForm.columnType == 2
            ? _c(
                "el-form-item",
                { attrs: { label: "数据源：", prop: "datasource" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.placeholer },
                    model: {
                      value: _vm.dataForm.datasource,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "datasource", $$v)
                      },
                      expression: "dataForm.datasource",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 1 || _vm.dataForm.columnType == 4
            ? _c(
                "el-form-item",
                { attrs: { label: "自定义表单选择：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        display: "block",
                        "margin-bottom": "10px",
                      },
                      attrs: { placeholder: "请选择自定义表单" },
                      model: {
                        value: _vm.extAttrs.formId,
                        callback: function ($$v) {
                          _vm.$set(_vm.extAttrs, "formId", $$v)
                        },
                        expression: "extAttrs.formId",
                      },
                    },
                    _vm._l(_vm.customList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.tit, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "按钮名称：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写按钮名称" },
                    model: {
                      value: _vm.extAttrs.btnName,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "btnName", $$v)
                      },
                      expression: "extAttrs.btnName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "按钮图标：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写按钮图标" },
                    model: {
                      value: _vm.extAttrs.btnIcon,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "btnIcon", $$v)
                      },
                      expression: "extAttrs.btnIcon",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 4
            ? _c(
                "el-form-item",
                { attrs: { label: "显示列表序号：" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-text": "是",
                      "active-value": "1",
                      "inactive-text": "否",
                      "inactive-value": "0",
                    },
                    model: {
                      value: _vm.extAttrs.showSort,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "showSort", $$v)
                      },
                      expression: "extAttrs.showSort",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 4
            ? _c(
                "el-form-item",
                { attrs: { label: "显示过滤查询：" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": true,
                      "inactive-value": false,
                      "active-text": "是",
                      "inactive-text": "否",
                    },
                    model: {
                      value: _vm.extAttrs.showFilter,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "showFilter", $$v)
                      },
                      expression: "extAttrs.showFilter",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 4
            ? _c(
                "el-form-item",
                { attrs: { label: "显示分页：" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content:
                          "建议开启，否则页面渲染表格方式不会采用异步查询数据",
                        placement: "top",
                      },
                    },
                    [_c("span", { staticClass: "el-icon-warning-outline" })]
                  ),
                  _c("el-switch", {
                    attrs: {
                      "active-value": true,
                      "inactive-value": false,
                      "active-text": "是",
                      "inactive-text": "否",
                    },
                    model: {
                      value: _vm.extAttrs.showPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "showPage", $$v)
                      },
                      expression: "extAttrs.showPage",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 4
            ? _c(
                "el-form-item",
                { attrs: { label: "显示操作：" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": true,
                      "inactive-value": false,
                      "active-text": "是",
                      "inactive-text": "否",
                    },
                    model: {
                      value: _vm.extAttrs.showOpt,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "showOpt", $$v)
                      },
                      expression: "extAttrs.showOpt",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 7
            ? _c(
                "el-form-item",
                { attrs: { label: "是否动态请求：" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": true,
                      "inactive-value": false,
                      "active-text": "是",
                      "inactive-text": "否",
                    },
                    model: {
                      value: _vm.extAttrs.dynamic,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "dynamic", $$v)
                      },
                      expression: "extAttrs.dynamic",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 7 ||
          _vm.dataForm.columnType == 5 ||
          _vm.dataForm.columnType == 6
            ? _c(
                "el-form-item",
                { attrs: { label: "请求路径：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写请求路径" },
                    model: {
                      value: _vm.extAttrs.url,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "url", $$v)
                      },
                      expression: "extAttrs.url",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 8
            ? _c(
                "el-form-item",
                { attrs: { label: "附件类型编码：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写附件类型编码" },
                    model: {
                      value: _vm.extAttrs.atttype,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "atttype", $$v)
                      },
                      expression: "extAttrs.atttype",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.columnType == 8
            ? _c(
                "el-form-item",
                { attrs: { label: "附件类型集：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写附件类型,逗号分隔" },
                    model: {
                      value: _vm.extAttrs.types,
                      callback: function ($$v) {
                        _vm.$set(_vm.extAttrs, "types", $$v)
                      },
                      expression: "extAttrs.types",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("br"),
          _c(
            "el-form-item",
            { attrs: { label: "列数：", prop: "columnCount" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "列数" },
                  model: {
                    value: _vm.dataForm.columnCount,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "columnCount", $$v)
                    },
                    expression: "dataForm.columnCount",
                  },
                },
                _vm._l(_vm.columnCountOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "列宽：", prop: "columnWidth" } },
            [
              _c("el-input", {
                attrs: { placeholder: "排序" },
                model: {
                  value: _vm.dataForm.columnWidth,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "columnWidth", $$v)
                  },
                  expression: "dataForm.columnWidth",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序：", prop: "sort" } },
            [
              _c("el-input", {
                attrs: { placeholder: "排序" },
                model: {
                  value: _vm.dataForm.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "sort", $$v)
                  },
                  expression: "dataForm.sort",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }